module.exports = __webpack_public_path__ + "iphone18pro-black.2221c439.png";